// extracted by mini-css-extract-plugin
export default {"APage":"APage__APage___IWb4J","APageFullScreen":"APage__APageFullScreen___CWHiQ"};